export default "__VITE_ASSET__CZ4b_k94__"